const EventBus = window.EventBus;

export const NewToggleConditionSelector = {
  template: //html
  `
    <div class="relative search-dropdown" id="newToogleConditionSelector">
      <div :class="conditionSelected == 1 ? component : conditionSelected" class="w-full flex content-between items-center h-10 new-condition-selector-content">
        <button v-for="item in items" @click="toggle(component, item); setActive(item);" :class="item == 1 ? component : item.toLowerCase()" class="py-1 px-4 text-center relative w-full" type="button">{{ item == '1' ? 'Demo' : item }}</button>
      </div>
    </div>
  `,
  data: function () {
    return {
      show: false,
      uniqueInList: null,
      theme_directory: window.theme_directory,
      conditionSelected: '',
      selected: [],
      original_selected:[],
      loaded: false,
      enable: true,
    };
  },
  props: [
    "component",
    "title",
    "items",
    "initialSelection",
    "collapse",
    "pivot",
    "clickClosed",
    "optionsCount",
  ],
  mounted() {
    EventBus.$on("CLOSE_ALL_OPEN_COMPONENTS", () => {
      if (this.show) this.show = false;
    });
    EventBus.$on(
      "CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION",
      () => {
        this.clearSelection();
      }
    );
    EventBus.$on("NEW_TOGGLE_LIST_ABSOLUTE_ENTRY_POINT", () => {});
  },
  methods: {
    setActive(condition) {
      this.conditionSelected = condition == 1 ? this.component : condition.toLowerCase();
    },
    entryPoint(items) {

     items.filter( item => {

          let replace = item.replace(/ /g, "-").replace(/---/g, "-").toLowerCase()
          let replace2 = item.replace(/ /g, "-").replace(/---/g, "-")

          if ( this.initialSelection.includes(replace) || this.initialSelection.includes(replace2) ){
            if(this.component=='condition'){
              this.selected.push(this.$t(item).toUpperCase())
            }
            else{
              this.selected.push(item.toUpperCase())
            }
            this.original_selected.push(item.toUpperCase())
          }

        }
      );

      this.$emit("updatechecked", {
        component: this.component,
        selected: this.original_selected,
      });


    },
    clearSelection() {
      this.selected = [];
      this.original_selected = [];
      let conditionSelectorDiv = document.querySelectorAll('#newToogleConditionSelector > div');
      conditionSelectorDiv.forEach(div => {
        if (div.classList.contains(this.conditionSelected)) div.classList.remove(this.conditionSelected);
      });
      this.$emit("updatechecked", {
        component: this.component,
        selected: this.selected,
      });
    },
    display() {
      if (!this.hasItems() || !this.enable) return;
      this.show = !this.show;
    },
    hasItems() {
      return this.items.length > 0;
    },
    toggle(component, item) {
      var enabled = true;

      if (this.original_selected.length > 0 && !this.original_selected.includes(item.toUpperCase())){
        this.original_selected = [];
        this.selected = [];

        this.original_selected.push(item.toUpperCase());
        this.selected.push(item.toUpperCase());

        this.$emit("updatechecked", {
          component,
          selected: this.original_selected,
        });

        this.$emit('updatetags', {
          component,
          selected: item,
          status: enabled
        });
      } else {
        if (this.original_selected.includes(item.toUpperCase())){
          let indexSelected
          enabled = false;

          if(this.component=='condition'){
            indexSelected = this.selected.indexOf(this.$t(item).toUpperCase())
          }
          else{
            indexSelected = this.selected.indexOf(item.toUpperCase())
          }

          let indexOriginalSelected = this.original_selected.indexOf(item.toUpperCase())

          this.selected.splice(indexSelected,1);
          this.original_selected.splice(indexOriginalSelected,1);

        }
        else {
          if(this.component=='condition'){
            this.selected.push(this.$t(item).toUpperCase());
          }
          else{
            this.selected.push(item.toUpperCase());
          }

          this.original_selected.push(item.toUpperCase());
        }

        this.$emit("updatechecked", {
          component,
          selected: this.original_selected,
        });

        this.$emit('updatetags', {
          component,
          selected: item,
          status: enabled
        })
      }
    },
    log(text){
      console.log(text)
    },
    toCapitalize(text){
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    getCount(item) {
      //let newItem =this.toCapitalize(item)
      if (this.optionsCount && this.optionsCount[item.toUpperCase()])
        return `(${this.optionsCount[item.toUpperCase()]})`;
      else
        return "";
    },
    capitalizeItems(items) {
      var arrTwo = items;
      for (var i = 0; i < arrTwo.length; i++) {
        arrTwo[i] = arrTwo[i].toUpperCase().trim();
      }

      const filteredArray = arrTwo.filter(function (ele, pos) {
        return arrTwo.indexOf(ele) == pos;
      });
      return filteredArray;
    },
  },
  watch: {
    original_selected(oldVal, newVal) {
      if(oldVal !== newVal) this.$parent.removeConditionTag(newVal[0]);
      if(oldVal.length === 0 && newVal.length === 0) this.conditionSelected = '';
    },
    items(items) {

      if (!this.loaded) {
        this.entryPoint(items);
        this.loaded = true;
        // this.uppercaseItems;
      }

    },
  },
  computed: {
    disabled() {
      return !this.hasItems() || !this.enable;
    },
    isResponsive() {
      return !this.disableResponsive == true;
    },
  },
};
